module.exports = "/shared/img/slip-arrow-up.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/slip-arrow-up.png
// module id = 452
// module chunks = 13